<div *ngIf="dateOfBirth">
  <strong>DOB: </strong>
  {{ dateOfBirth | moment | amDateFormat: dateFormat }}
</div>
